import Vuex from "vuex";
import Vue from "vue";

import createPersistedState from "vuex-persistedstate";
import auth from "./auth";

Vue.use(Vuex);

const config = {
  plugins: [createPersistedState()],
  modules: {
    auth
  },
  state: () => {},
  actions: {},
  mutations: {},
  getters: {}
};
createResetHandler(config);

export default new Vuex.Store(config);

/*
  Dynamically add mutation & action to root and each module for resetting state
  to initial state only if:
  - if there's state property set for module
  - state property is a function that return the initial state object
  ** state must be a function in order to cache initial state
*/
export function createResetHandler(store) {
  const RESET_MODS = [];
  Object.keys(store.modules).forEach(modName => {
    const mod = store.modules[modName];

    if (!Object.prototype.hasOwnProperty.call(mod, "state")) return;
    if (typeof mod.state !== "function") return;

    if (!Object.prototype.hasOwnProperty.call(mod, "mutations"))
      mod.mutations = {};
    if (!Object.prototype.hasOwnProperty.call(mod, "actions")) mod.actions = {};

    RESET_MODS.push(modName);

    if (!Object.prototype.hasOwnProperty.call(mod, modName + "_RESET_STATE")) {
      mod.mutations[modName + "_RESET_STATE"] = function RESET_STATE(state) {
        const s = mod.state();
        Object.keys(s).forEach(key => (state[key] = s[key]));
      };
    }

    if (!Object.prototype.hasOwnProperty.call(mod, modName + "resetState")) {
      mod.actions[modName + "_resetState"] = function resetState({ commit }) {
        commit(modName + "_RESET_STATE");
      };
    }
  });

  store.actions.resetAllState = function RESET_ALL_STATE({ commit }) {
    RESET_MODS.forEach(m => commit(`${m}/${m}_RESET_STATE`));
  };
}
